export const RESET_TABS = "RESET_TABS";
export const RESET_TAB = "RESET_TAB";
export const RESET_ERROR = "TABS_RESET_ERROR";

export const GET_TABS = "GET_TABS";
export const SET_TABS = "SET_TABS";

export const API_ERROR = "TABS_API_ERROR";

export const GET_TAB = "GET_TAB";
export const SET_TAB = "SET_TAB";

export const EDIT_TAB = "EDIT_TAB";
export const EDIT_TAB_SUCCESS = "EDIT_TAB_SUCCESS";

export const CREATE_TAB = "CREATE_TAB";
export const CREATE_TAB_SUCCESS = "CREATE_TAB_SUCCESS";

export const DELETE_TAB = "DELETE_TAB";
export const DELETE_TAB_SUCCESS = "DELETE_TAB_SUCCESS";
